(function () {


  let styleAdded = false;
  let styleElement = null;

  function hideElement() {
    if (!styleAdded) {
      styleElement = document.createElement('style');
      styleElement.textContent = '.rps-result-count-wrapper-desktop { visibility: hidden !important; }';
      document.head.insertBefore(styleElement, document.head.firstChild);
      styleAdded = true;
    }
  }

  function showElement() {
    if (styleElement && styleElement.parentNode) {
      styleElement.remove();
      styleAdded = false;
    }
  }

  function updateProductCount() {
    const el = document.querySelector('.rps-result-count-wrapper-desktop');
    if (el) {
      // Replace text
      if (!window.keepProductsLabel) {
        const newText = el.textContent.replace(/products?/gi, 'Titles');
        el.textContent = newText;
      }
      
      // Show the element
      showElement();
      el.style.visibility = 'visible';
      el.style.opacity = '1';

      return true; // Success
    }
    return false; // Element not found
  }

  function updateSortOptions() {
    const sortOptions = document.querySelectorAll('.rps-sort-option');
    let updated = false;

    sortOptions.forEach(function (option) {
      const p = option.querySelector('p');
      if (p) {
        const text = p.textContent.trim();
        if (text === 'Date, New to old' || text === 'Date, new to old') {
          p.textContent = 'Recently Added';
          updated = true;
          console.log('Sort option updated to "Recently Added"');
        }
      }
    });

    if (!updated && sortOptions.length > 0) {
      console.log('Sort options found but no match. Options:',
        Array.from(sortOptions).map(o => o.textContent.trim()));
    }

    return updated;
  }

  function updateSortByValue() {
    const sortByValue = document.querySelector('.rps-sort-by-value');
    if (sortByValue) {
      const text = sortByValue.textContent.trim();
      if (text === 'Date, New to old' || text === 'Date, new to old') {
        sortByValue.textContent = 'Recently Added';
        console.log('Sort by value updated to "Recently Added"');
      }
    }
  }

  // Hide immediately
  hideElement();

  // Try to update immediately
  if (!updateProductCount()) {
    // If element doesn't exist yet, keep trying
    let attempts = 0;
    const maxAttempts = 20;

    const interval = setInterval(function () {
      attempts++;
      if (updateProductCount() || attempts >= maxAttempts) {
        clearInterval(interval);
        if (attempts >= maxAttempts) {
          // Give up and show whatever is there
          showElement();
        }
      }
    }, 100); // Check every 100ms
  }

  // Update sort options - try multiple times
  setTimeout(updateSortOptions, 100);
  setTimeout(updateSortOptions, 500);
  setTimeout(updateSortOptions, 1000);
  setTimeout(updateSortOptions, 2000);

  // Update sort by value - try multiple times
  setTimeout(updateSortByValue, 100);
  setTimeout(updateSortByValue, 500);
  setTimeout(updateSortByValue, 1000);
  setTimeout(updateSortByValue, 2000);

  // Also run on DOM ready and load as backup
  document.addEventListener('DOMContentLoaded', function () {
    updateProductCount();
    updateSortOptions();
    updateSortByValue();
  });

  window.addEventListener('load', function () {
    updateProductCount();
    updateSortOptions();
    updateSortByValue();
  });

  // Watch for the sort dropdown to open
  document.addEventListener('click', function (e) {
    // Check if sort dropdown was clicked
    if (e.target.closest('.rps-sort-select-dropdown-container') ||
      e.target.closest('.rps-sort-header')) {
      setTimeout(updateSortOptions, 50);
      setTimeout(updateSortOptions, 200);
    }

    // Check if a sort option was clicked
    if (e.target.closest('.rps-sort-option')) {
      setTimeout(updateSortByValue, 50);
      setTimeout(updateSortByValue, 200);
    }
  });

  // Watch for changes when filters are applied
  setTimeout(function () {
    const el = document.querySelector('.rps-result-count-wrapper-desktop');
    if (el) {
      const observer = new MutationObserver(function () {
        hideElement();
        setTimeout(updateProductCount, 50);
      });
      observer.observe(el, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Watch the entire sort container for any changes
    const sortContainer = document.querySelector('.rps-sort-select-dropdown-container');
    if (sortContainer) {
      const sortObserver = new MutationObserver(function () {
        updateSortOptions();
        updateSortByValue();
      });
      sortObserver.observe(sortContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });
    }

    // Also watch the options wrapper directly
    const optionsWrapper = document.querySelector('.rps-sort-options-wrapper');
    if (optionsWrapper) {
      const optionsObserver = new MutationObserver(function () {
        updateSortOptions();
      });
      optionsObserver.observe(optionsWrapper, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });
    }

    // Watch the sort header specifically for value changes
    const sortHeader = document.querySelector('.rps-sort-header');
    if (sortHeader) {
      const headerObserver = new MutationObserver(function () {
        updateSortByValue();
      });
      headerObserver.observe(sortHeader, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }, 500);
})();
